




















































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { GrupoDeCliente, UnidadeDeTempo } from '@/models'
import { listasDeUnidadesDeTempo } from '@/shareds/cliente-shareds'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DialogoDeEdicaoDoGrupoDoCliente from '@/components/cliente/DialogoDeEdicaoDoGrupoDoCliente.vue'
import { GrupoDeClienteUseCase } from '@/usecases/cliente/GrupoDeClienteUseCase'
import SeletorDeGruposEconomicos from '@/components/loja/SeletorDeGruposEconomicos.vue'
import { GrupoEconomico } from '@/models/GrupoEconomico'

@Component({
	components: { 
		DialogoDeEdicaoDoGrupoDoCliente, 
		Confirmacao,
		SeletorDeGruposEconomicos,
	},
})
export default class TelaDeGrupoDoCliente extends Vue {
	@Ref() dialogoDeEdicaoDoGrupoDoCliente!: DialogoDeEdicaoDoGrupoDoCliente

	grupoDeClienteUseCase = new GrupoDeClienteUseCase()

	grupos: GrupoDeCliente[] = []
	carregando = false
	excluindo: string[] = []
	grupoEmEdicao: GrupoDeCliente | null = null
	grupoEconomico: GrupoEconomico | null = null

	pagina = 1
	itensPorPagina = 12

	async created() {
		await this.buscar()
	}

	async buscar() {
		try {
			this.carregando = true
			const grupoEconomicoId = this.grupoEconomico ? this.grupoEconomico.id : null
			this.grupos = (await this.grupoDeClienteUseCase.findPageGrupoDeCliente({grupoEconomicoId: grupoEconomicoId})).content
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	get planosFiltrados() {
		return this.grupos
	}

	get totalFiltrados() {
		return this.planosFiltrados.length
	}

	get totalPaginas() {
		return Math.max(1, Math.ceil(this.totalFiltrados / this.itensPorPagina))
	}

	get gruposPaginados() {
		const inicio = (this.pagina - 1) * this.itensPorPagina
		const fim = inicio + this.itensPorPagina
		return this.planosFiltrados.slice(inicio, fim)
	}

	get faixaPaginacao() {
		if (this.totalFiltrados === 0) return '0 - 0 de 0'

		const inicio = (this.pagina - 1) * this.itensPorPagina + 1
		const fim = Math.min(this.pagina * this.itensPorPagina, this.totalFiltrados)

		return `${inicio} - ${fim} de ${this.totalFiltrados}`
	}

	@Watch('itensPorPagina')
	onItensPorPaginaChanged() {
		this.pagina = 1
	}

	@Watch('grupos')
	onGrupoChanged() {
		if (this.pagina > this.totalPaginas) this.pagina = this.totalPaginas
	}

	displayUnidadeDeTempo(unidade: UnidadeDeTempo) {
		return listasDeUnidadesDeTempo.find(item => item.value == unidade)?.text || ''
	}

	atualizarGrupo(grupo: GrupoDeCliente) {
		const indice = this.grupos.findIndex(p => p.id === grupo.id)
		indice === -1 ? this.grupos.push(grupo) : this.grupos.splice(indice, 1, grupo)
	}

	abrirDialogoDeEdicao(grupo: GrupoDeCliente) {
		this.grupoEmEdicao = grupo
		this.dialogoDeEdicaoDoGrupoDoCliente.mostrar(grupo)
	}

	indiceGlobal(id: string) {
		return this.grupos.findIndex(p => p.id === id)
	}

	async excluirGrupo(grupoDeClienteId: string) {

		try {
			this.excluindo.push(grupoDeClienteId)
			await this.grupoDeClienteUseCase.deletarGrupoDeCliente(grupoDeClienteId)

			this.grupos = this.grupos.filter(({ id }) => id !== grupoDeClienteId)
		} catch (error: any) {
			AlertModule.setError(error.response?.data?.[0] ?? error)
		} finally {
			this.excluindo = this.excluindo.filter(id => id !== grupoDeClienteId)
		}
	}

	limparFiltro(){
		this.grupoEconomico = null
		this.buscar()
	}
}
